import React, { useContext } from 'react';
import { ICopilotRepositoryContextValue } from '../../types';

export const CopilotRepositoryContext = React.createContext<ICopilotRepositoryContextValue | undefined>(undefined);

export const useCopilotRepositoryContext = () => useContext(CopilotRepositoryContext);
